<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import OverviewUpcomingItem from './OverviewUpcomingItem.vue'
import { Link } from '@inertiajs/vue3'

const page     = usePage()
const upcoming = computed(() => page.props.__neo_main?.__data?.upcoming ?? [])
</script>

<template>
    <div>
        <div v-if="!upcoming.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">{{ $t('dashboard.no_upcoming') }}</div>
        <OverviewUpcomingItem
            v-for="(item, i) in upcoming"
            :key="item.id"
            :item="item"
            :worker-index="i"
        />
    </div>
</template>
